declare const require: NodeRequire & {
  context: (path: string, deep: boolean, filter: RegExp) => {
    keys: () => string[];
    (key: string): string;
  };
};

const svgContext = require.context(
  '!!raw-loader!../../../../app/assets/images/svg/icons-lj-styleguide-2025',
  false,
  /\.svg$/,
);

function toCamelCase(filename: string): string {
  return filename
    .replace(/\.svg$/, '')
    .replace(/^\.\//, '')
    .replace(/-([a-z])/g, (_, char) => char.toUpperCase());
}

const ICONS: Record<string, string> = {};

svgContext.keys().forEach((key: string) => {
  ICONS[toCamelCase(key)] = svgContext(key);
});

export type IconName = keyof typeof ICONS;

export default ICONS;
